import { darken } from '@mui/material/styles';

const VSUITE = '#54fabd';

export const brand = {
  black: { main: '#130d31' },
  vfile: { main: '#39a0ed' },
  vship: { main: '#ae00ff' },
  vsuite: {
    main: VSUITE,
    text: darken(VSUITE, 0.2),
    hover: darken(VSUITE, 0.1),
  },
  vlearn: { main: '#f61067' },
} as const;
